// @flow

// Libs
import React from 'react'

// Components
import SvgIcon from './SvgIcon'
import svg from '../svg/tick.svg'

// Types
type Props = {
  size?: number,
  color?: string,
  style?: Object,
}

// Exports
export default function Sort({ size = 12, color = 'rgb(0, 0, 0)', style = {} }: Props): React.Element<any> {
  return <SvgIcon size={size} color={color} src={svg} style={style} />
}
